import { useRecoilState } from 'recoil';
import { aIvAccessToken, aIvIdentityToken, aJitsiDomain, aJitsiRoom, aJitsiToken, aMsAccessToken } from 'shared-state/tokens/atoms';

export const useIvicosAccesToken = (tennantId: string): any => {
    return useRecoilState(aIvAccessToken(tennantId));
};
export const useIvicosIdentityToken = (tennantId: string): any => {
    return useRecoilState(aIvIdentityToken(tennantId));
};
export const useMicrosoftAccessToken = (tennantId: string): any => {
    return useRecoilState(aMsAccessToken(tennantId));
};

export const useLocalJitsiToken = (roomId: string): any => {
    return useRecoilState(aJitsiToken(roomId));
};

export const useLocalJitsiRoom = (roomId: string): any => {
    return useRecoilState(aJitsiRoom(roomId));
};

export const useLocalJitsiDomain = (roomId: string): any => {
    return useRecoilState(aJitsiDomain(roomId));
};
